import { Box, Inline, Stack } from '@atlaskit/primitives';
import React from 'react';
import Image from '@atlaskit/image';
import { FormattedMessage, useIntl } from 'react-intl';
import { CATEGORIES } from '../components/menu-page/CategorySidebar';
import { AnnouncementCoreData } from './announcements';
import { MediaStyles } from '../components/menu-page/AnnouncementCard';
import { messages } from './messages';
import shortcutGif from '../assets/images/shortcut.gif';
import chatShortcutImageForMac from '../assets/images/chat_shortcut_mac.png';
import searchShortcutImageForMac from '../assets/images/search_shortcut_mac.png';
import chatShortcutImageForWindows from '../assets/images/chat_shortcut_windows.png';
import searchShortcutImageForWindows from '../assets/images/search_shortcut_windows.png';
import { isMacOs } from '../utils/isMacOS';

const ShortcutAnnouncement = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Box>
			<Box xcss={MediaStyles}>
				<Inline alignBlock="stretch" space="space.200">
					<Image alt={formatMessage(messages.shortcutGifAlt)} src={shortcutGif} width="65%" />
					<Stack space="space.100" spread="space-between">
						<Image
							alt={formatMessage(messages.chatShortcutAlt)}
							src={isMacOs() ? chatShortcutImageForMac : chatShortcutImageForWindows}
						/>
						<Image
							alt={formatMessage(messages.searchShortcutAlt)}
							src={isMacOs() ? searchShortcutImageForMac : searchShortcutImageForWindows}
						/>
					</Stack>
				</Inline>
			</Box>
			<Box>
				<FormattedMessage {...messages.shortcutIntro} />
				<Stack as="ul">
					<li>
						<b>
							<FormattedMessage {...messages.chatTitle} />
						</b>
						<Stack as="ul">
							<li>
								{isMacOs() ? (
									<FormattedMessage {...messages.macChatAccess} />
								) : (
									<FormattedMessage {...messages.windowsChatAccess} />
								)}
							</li>
						</Stack>
					</li>
					<li>
						<b>
							<FormattedMessage {...messages.searchTitle} />
						</b>
						<Stack as="ul">
							<li>
								<b>
									<FormattedMessage {...messages.searchAnytimeTitle} />
								</b>
								&nbsp;
								<FormattedMessage {...messages.searchAnytimeDesc} />
							</li>
							<li>
								<b>
									<FormattedMessage {...messages.searchNewTabTitle} />
								</b>
								&nbsp;
								{isMacOs() ? (
									<FormattedMessage {...messages.searchNewTabMacDesc} />
								) : (
									<FormattedMessage {...messages.searchNewTabWindowsDesc} />
								)}
							</li>
						</Stack>
					</li>
				</Stack>
			</Box>
		</Box>
	);
};

export const ShortCutAnnouncementData: AnnouncementCoreData = {
	title: messages.shortcutTitle.defaultMessage,
	content: <ShortcutAnnouncement />,
	tags: [CATEGORIES.AI_SEARCH, CATEGORIES.CHAT, CATEGORIES.EXTENSION],
};

export default ShortcutAnnouncement;
